import 'bootstrap/dist/css/bootstrap.min.css';

import './Home.css';

import profile from "../images/profile.jpg"
import hero from "../images/hero.jpg"

import React from 'react';

import Header from "../Header/Header"

function Home() {
  return (
    <React.Fragment>

      <Header />

      <div style={{ backgroundImage: `url(${hero})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center' }} className="hero">
        <div className="p-4">
          <h1 className="text">Wholehearted Psychotherapy</h1>
        </div>
      </div>

      <div className="section">
        <div className="d-flex flex-column flex-md-row">
          <div className="text-center text-md-start">
            <img className="about-image" src={profile} alt="Gayathri Ram Mohan" />
          </div>

          <div>
              <h4 className="text font-weight-light">Welcome to Wholehearted Psychotherapy!</h4>

              <p className="text">
                My name is Gayathri Ram Mohan, Licensed Clinical Social Worker MSW, MA (Holistic Counseling Psychology), LCSW #102168.
              </p>

              <p className="text">
                Some life experiences create open wounds that can have a paralyzing impact in the way we see the world, interact or make meaning. This can cause a certain numbness to life, leading one to shy away from intimate relationships and struggle with boundaries among friends or family.
              </p>

              <p className="text">
                Sometimes it is the critical voice in our heads that hijacks our whole being, leading us to spiral into the belief of "I am not okay." I strive to provide a compassionate and non-judgmental space – a space where you have the chance to learn, reflect, and plant seeds of self-compassion. I look forward to guiding through each person's unique journey of introspection and understanding.
              </p>

              <div className="quote-highlight">
                <p className="text mb-0">
                  Poet Rumi sums up my philosophy when he writes <span className='bold'>"out beyond ideas of wrong doing and right doing there is a field. I'll meet you there."</span> This is the space I strive to provide in therapy.
                </p>
              </div>

              <p className="text">
                I have worked through my own trauma, insecurities surrounding my body, gender and diversity in therapy. I understand how difficult it is to bring these topics to the therapy room. I bring sensitivity and compassion so individuals & couples can explore, introspect and make meaning of their experiences. Transcending and living a full and wholesome life is possible.
              </p>

              <p className="text mb-2">
                Schedule a free 15-minute consultation:
              </p>
            <a href="tel:4085282440" className="cta-phone">(408) 528-2440</a>
          </div>
        </div>
      </div>

    </React.Fragment>
  );
}

export default Home;
